import { environment } from '../../../environments/environment';

export class SynthesisModel
{
    // tslint:disable: variable-name
    id_user: number = undefined;
    id_building: number = undefined;
    etablissement: string = undefined;
    adresse: string = undefined;
    zipcode: string = undefined;
    town: string = undefined;
    dept: string = undefined;
    auteur: string = undefined;
    directeur: string = undefined;
    phone: string = undefined;
    email: string = undefined;
    lastNote: number = undefined;
    previousNote: number = undefined;
    notecat: string = undefined;
    importantRisks: Array<string> = undefined;
    id_diagnostic: number = undefined;
    rapport: string = undefined;


    get pdfUrl(): string
    {
        if (this.rapport === 'API-PDF'
        || this.rapport === 'API'     ) {
            return environment.apiBaseUrl + '/report-pdf/' + this.id_diagnostic
            + '?mode=pdf&token=' + localStorage.getItem('access_token');
        }
        return '';
    }

    constructor(values: object)
    {
        if (values) { this.exchange(values); }
    }

    exchange(values: object = {}): void
    {
        // tslint:disable-next-line: prefer-const
        for (let p in values) {
            if(p=='lastNote') {
                this[p] = parseFloat(values[p]);
            }
            else if (this.hasOwnProperty(p) && values.hasOwnProperty(p)) {
                this[p] = values[p];
            }
        }
    }
}
